import styled from 'styled-components';

export default styled.div`
    display: -ms-grid;
    display: grid;
    grid-template-columns: 1fr;
    -ms-grid-columns: 1fr;
    margin-top: 10px;
    min-height: 20px;
`;



// WEBPACK FOOTER //
// ./src/Components/Layout/LayoutSingleColumn.tsx